import { useQuery } from '@apollo/react-hooks';
import { GET_CONFIGS } from '../../graphql/common/query';
import { Configs } from '../../graphql/common/types/Configs';

export const useGetConfigs = () => {
  return useQuery<Configs>(GET_CONFIGS, {
    fetchPolicy: 'cache-first',
  });
};
